export const VIDEO_SPEED_UP_TIME = 2;

export const VIDEO_FPS = 24;

// should be but it's not work correctly 1000 / VIDEO_FPS
export const VIDEO_MSPF = 200;

export const VIDEO_PLAY_ICON = {
  WIDTH: 300,
  HEIGHT: 300
};
